import React from "react";

interface ProgressProps {
	total: number;
	current: number;
	colors: {
		bar: "green";
		background: string;
	};
	height: number;
}

const Progress = ({ total, current, colors, height }: ProgressProps) => {
	const percent = (current / total) * 100;
	return (
		<div
			className={`bg-${colors?.background} overflow-hidden rounded-full h-${height}`}
		>
			<div
				style={{ width: `${percent}%` }}
				className={`transition-all block rounded-full h-${height} bg-${colors.bar}`}
			></div>
		</div>
	);
};

Progress.defaultProps = {
	colors: {
		bar: "green",
		background: "gray",
	},
	height: 2,
};

export default Progress;
